import axios from 'axios';
import { getCurrentUser } from './authService';

//const API_URL = 'http://localhost:5000/api/';
const API_URL = `${process.env.REACT_APP_API_URL}/`;

export const getUtxos = async () => {
  try {
    const user = getCurrentUser();
    const response = await axios.get(`${API_URL}utxos`, {
      headers: {
        Authorization: `Bearer ${user.token}`, // Enviar en formato 'Bearer token'
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener UTXOs');
  }
};
